<template>
    <div class="">
        <h1>About</h1>
    </div>
</template>

<script>
export default {
    name: 'wellful-about',
    data() {
        return {
            activeItem: 0
        }
    },
    components: {}
}
</script>

<style scoped></style>
